module.exports = __webpack_public_path__ + "img/ic_result03.629ad40f.png";